import Dialog from '@mui/material/Dialog'
import Box from '@mui/material/Box'
import ZendeskLink from 'components/Common/ZendeskLink'
import { useNavigate } from 'react-router-dom'
import { PRIMARY_BUTTON } from 'themes/theme'
import Button from 'components/Common/Button'
import { Typography } from '@mui/material'
import iconSuccess from 'assets/icons/fi_check-circle.svg'

const sx = {
  dialogContainer: {
    textAlign: 'center',
    color: 'rgb(22,21,84)',
  }
}

const SuccessModal = ({ title, open, subTitle, onClose }) => {
  const navigate = useNavigate()
  return (
    <Dialog
      sx={sx.dialogContainer}
      fullScreen
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          backgroundColor: '#F2F8Fc',
          boxShadow: 'none',
        },
      }}
    >
      <Box className="d-flex align-items-center flex-column justify-content-center h-100">
        <h2 style={{ color: '#25245F', fontWeight: 900, fontFamily: 'poppins', boxSizing: 'border-box' }}>{title}</h2>

        <Box
          sx={{
            mt: 5,
            mb: 2,
          }}
        >
          <img src={iconSuccess} alt="success" height={25} className="modal-title-img2" />
        </Box>
        <Typography variant="h5" sx={{ color: '#25245F' }}>
          {subTitle}
        </Typography>
        <p className='font14px' style={{ color: '#25245F', marginTop: '20px' }}>
          Your payment has been processed successfully, you'll receive an email receipt shortly.
        </p>
        <Button
          size="large"
          onClick={() => {
            onClose()
            window.scrollTo(0, 0)
            navigate('/')
          }}
          type={PRIMARY_BUTTON}
          sx={{ margin: '40px 0 0 0', padding: '7px 40px' }}
        >
          Go to Dashboard
        </Button>
        <div style={{ marginTop: '9%' }}>
          <ZendeskLink />
        </div>
      </Box>
    </Dialog>
  )
}

export default SuccessModal
